import { z } from 'zod';

export const NotVerificationSignInErrorSchema = z.object({
    data: z.object({
        verificationToken: z.string(),
    }),
});
